import * as types from '../mutation-types'
import { validateAuthRequest, checkGrant, issueAuthCode } from '@/store/api/oauth'

const state = {
  pendingAuthRequest: null,
  partnerInfo: null,
  requestedScopes: []
}

const getters = {
  oauthPendingAuthRequest: (state) => state.pendingAuthRequest,
  oauthPartnerInfo: (state) => state.partnerInfo,
  oauthRequestedScopes: (state) => state.requestedScopes
}

const mutations = {
  [types.SET_OAUTH_PENDING_AUTH_REQUEST](state, data) {
    state.pendingAuthRequest = data
  },
  [types.SET_OAUTH_PARTNER_INFO](state, data) {
    state.partnerInfo = data
  },
  [types.SET_OAUTH_REQUESTED_SCOPES](state, data) {
    state.requestedScopes = data
  },
  [types.CLEAR_OAUTH_PENDING_REQUEST](state) {
    state.pendingAuthRequest = null
    state.partnerInfo = null
    state.requestedScopes = []
  }
}

const actions = {
  async validateAndStoreAuthRequest({ commit }, params) {
    const response = await validateAuthRequest(params)
    commit(types.SET_OAUTH_PENDING_AUTH_REQUEST, params)
    commit(types.SET_OAUTH_PARTNER_INFO, response.partner)
    commit(types.SET_OAUTH_REQUESTED_SCOPES, response.scopes)
    return response
  },
  async checkGrant(_, params) {
    const response = await checkGrant(params)
    return response.is_granted
  },
  async issueAuthCode(_, params) {
    const response = await issueAuthCode(params)
    console.log('[OAuth] issueAuthCode response:', response)
    return response.authorization_code
  },
  clearPendingRequest({ commit }) {
    commit(types.CLEAR_OAUTH_PENDING_REQUEST)
  }
}

export default { state, getters, mutations, actions }
